import type { FoodEntry } from '../api/types'

interface Props {
  entries: FoodEntry[]
  emptyMessage?: string
}

const fmtDate = (iso: string) => {
  // The API returns server-local ISO strings with offset (e.g. -04:00).
  // `toLocaleString` will preserve that offset when rendering the wall-clock time.
  const d = new Date(iso)
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const num = (n: number | null) => (n === null || n === undefined ? '—' : n)

const EntryTable: React.FC<Props> = ({ entries, emptyMessage = 'No entries yet.' }) => {
  if (entries.length === 0) {
    return <p className="text-gray-500">{emptyMessage}</p>
  }
  return (
    <div className="overflow-x-auto rounded border border-gray-200">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500">
          <tr>
            <th className="px-3 py-2">When</th>
            <th className="px-3 py-2">Description</th>
            <th className="px-3 py-2">Qty</th>
            <th className="px-3 py-2 text-right">kcal</th>
            <th className="px-3 py-2 text-right">F (g)</th>
            <th className="px-3 py-2 text-right">C (g)</th>
            <th className="px-3 py-2 text-right">P (g)</th>
            <th className="px-3 py-2 text-right">Fib (g)</th>
            <th className="px-3 py-2">Notes</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.id} className="border-t border-gray-200 align-top">
              <td className="px-3 py-2 whitespace-nowrap text-gray-600">
                {fmtDate(e.consumedAt)}
              </td>
              <td className="px-3 py-2 font-medium text-gray-900">
                {e.description}
              </td>
              <td className="px-3 py-2 text-gray-700">{e.quantity ?? '—'}</td>
              <td className="px-3 py-2 text-right tabular-nums">{num(e.calories)}</td>
              <td className="px-3 py-2 text-right tabular-nums">{num(e.fat)}</td>
              <td className="px-3 py-2 text-right tabular-nums">{num(e.carbs)}</td>
              <td className="px-3 py-2 text-right tabular-nums">{num(e.protein)}</td>
              <td className="px-3 py-2 text-right tabular-nums">{num(e.fiber)}</td>
              <td className="px-3 py-2 text-gray-700">{e.notes ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default EntryTable
